export default __webpack_public_path__ + "static/media/twojk.2d289460.jpg";